export default class ServerValidatedFormDirective {

    constructor() {
        this.scope = {
            jfParentCtrl: '=',
            jfServerValidatedForm: '=',
            jfOnBeforeFormSubmit: '&',
            jfOnFormSubmit: '&',
            jfOnFormSubmitQueryParams: '<',
            jfOnFormSubmitPayload: '=',
            jfOnFormSubmitSuccess: '&',
            jfOnFormSubmitFail: '&',
            jfHideToasterNotifications: '<?'
        };
        this.restrict = 'A';
        this.controller = ServerValidatedFormController;
        this.bindToController = true;
        this.controllerAs = 'formCtrl';
    }
}

ServerValidatedFormDirective.META = {
    name: 'jfServerValidatedForm'
};

ServerValidatedFormDirective.$inject = [];

class ServerValidatedFormController {

    constructor(JFrogNotifications) {
        this.jfrogNotifications = JFrogNotifications;
    }

    $onInit() {
	    this.jfParentCtrl.onSubmit = this.onSubmit.bind(this);
    }

    onSubmit() {
        if (this.jfOnBeforeFormSubmit()) {
            return;
        }
        let payload = this.jfOnFormSubmitPayload;
        if ('build' in this.jfOnFormSubmitPayload && _.isFunction(this.jfOnFormSubmitPayload.build)) {
            payload = this.jfOnFormSubmitPayload.build();
        }

        let queryParams = this.jfOnFormSubmitQueryParams;
        let onSubmitPromise = this.jfOnFormSubmit({queryParams, payload}).$promise;
        onSubmitPromise
            .then(
                (response) => {
                    this.jfOnFormSubmitSuccess({response});
                })
            .catch(
                (response) => {
                    this.jfServerValidatedForm.validationParams = {};
                    let data = response.data;
                    if (data.errors) {
                        _.forOwn(data.errors, (errorData) => {
                            if (_.has(this.jfServerValidatedForm, errorData.field)) {
                                let field = this.jfServerValidatedForm[errorData.field];
                                let onChangeAfterError = () => {
                                    _.pull(field.$viewChangeListeners, onChangeAfterError);
                                    field.$setValidity(errorData.code, true);
                                };

                                let fieldName = field.$name;
                                this.jfServerValidatedForm.validationParams[fieldName] = errorData.arguments;

                                field.$viewChangeListeners.push(onChangeAfterError);
                                field.$setValidity(errorData.code, false);
                            } else if (!this.jfHideToasterNotifications) {
                                this.jfrogNotifications.create(
                                    {error: errorData.defaultMessage || 'Something went wrong: error' + errorData.code});
                            }
                        });
                    }
                    this.jfOnFormSubmitFail({response});

                });
    }
}

ServerValidatedFormController.$inject = ['JFrogNotifications'];



// WEBPACK FOOTER //
// ./modules/distribution/directives/jf-server-validated-form/jf-server-validated-form.component.js